module.exports = __webpack_public_path__ + "static/img/t-shirt_left.0203f92d.png";